module.exports = __webpack_public_path__ + "img/Payments.3eb40e95.svg";